import { reclaimCampaignRuleSchema } from "@redotech/redo-dispute-settings-common/reclaim-access-settings";
import * as z from "zod";

export const listReclaimCampaigns = {
  name: "listReclaimCampaigns" as const,
  input: z.object({}),
  output: z.object({ campaigns: z.array(reclaimCampaignRuleSchema) }),
};
